import React, { useMemo } from "react";
import { AutoRenewButton, GracePeriodButton, ReactivateButton, RenewButton, SubscribeButton, UpgradeButton } from "~/components";
import { useSdkContext } from "~/components/contexts";
import { ScmpPlusButton } from "~/components/rosetta/subscription-button/scmp-plus-button";
import { SubscriptionButtonContainer } from "~/components/rosetta/subscription-button/styles";
import { theme, useResponsive } from "~/lib/media";
import { EpaperButton } from "./epaper-button";
export const SubscriptionButton = ({
  className,
  location = "masthead",
  variant
}) => {
  const {
    rosettaInstance
  } = useSdkContext();
  const isMobile = useResponsive(theme.breakpoints.only("mobile"), false);
  const mastheadButton = rosettaInstance === null || rosettaInstance === void 0 ? void 0 : rosettaInstance.rulesEngine.getOutcome("ui.masthead.button");
  const buttonType = useMemo(() => mastheadButton === null || mastheadButton === void 0 ? void 0 : mastheadButton.getDisplayVariant({
    shouldIncludeEpaper: true,
    shouldIncludeScmpPlus: !isMobile
  }), [isMobile, mastheadButton]);
  const computedVariant = useMemo(() => buttonType === "SCMPPLUS" ? "dark-blue" : variant, [buttonType, variant]);
  const handlerRenderButton = () => {
    switch (buttonType) {
      case "AUTORENEW":
        return /*#__PURE__*/React.createElement(AutoRenewButton, {
          className: className
        });
      case "GRACEPERIOD":
        return /*#__PURE__*/React.createElement(GracePeriodButton, {
          className: className
        });
      case "REACTIVATE":
        return /*#__PURE__*/React.createElement(ReactivateButton, {
          className: className,
          location: location
        });
      case "RENEW":
        return /*#__PURE__*/React.createElement(RenewButton, {
          className: className
        });
      case "SUBSCRIBE":
        return /*#__PURE__*/React.createElement(SubscribeButton, {
          className: className,
          location: location
        });
      case "UPGRADE":
        return /*#__PURE__*/React.createElement(UpgradeButton, {
          className: className
        });
      case "EPAPER":
        return /*#__PURE__*/React.createElement(EpaperButton, {
          className: className
        });
      case "SCMPPLUS":
        return /*#__PURE__*/React.createElement(ScmpPlusButton, {
          className: className
        });
      default:
        return null;
    }
  };
  return /*#__PURE__*/React.createElement(SubscriptionButtonContainer, {
    $variant: computedVariant,
    "data-qa": "subscription-button"
  }, handlerRenderButton());
};
SubscriptionButton.displayName = "SubscriptionButton";